import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import CircleIcon from '@mui/icons-material/Circle';
import { useAuth } from '../providers/AuthProvider';
import Typography from '@mui/material/Typography';
import apiService from '../providers/ApiService';

const ratingColors = {
  red: 'error',
  yellow: 'warning',
  green: 'success'
};

export default function RatingButtons({ caseId }) {
  const [selectedRating, setSelectedRating] = useState(null);
  const { email } = useAuth();

  React.useEffect(() => {
    // Fetch previously selected rating when loading case
    const fetchRating = async () => {
      try {
        const data = await apiService.get(`/user/${email}/cases`);
        setSelectedRating(data.completedCases[caseId]);
      } catch (error) {
        console.error('Error fetching rating:', error);
      }
    };
    fetchRating();
  }, [caseId]);

  const completeCase = async (caseId, rating) => {
    try {
      await apiService.put(`/user/${email}/cases/${caseId}`, {
        rating: rating
      });

      setSelectedRating(rating);
      //success
    } catch (error) {
      console.error('Failed to mark case as complete', error);
    }
  };

  return (
    <>
      <Typography
        sx={{
          display: 'flex',
          justifyContent: 'center',
          mt: { xs: 2, md: 4 }
        }}
        component="p"
        variant="subtitle1"
        align="center"
        color="text.secondary">
        Rate my performance
      </Typography>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          mt: { xs: 2, md: 4 }
        }}>
        <Stack direction="row" spacing={2}>
          {Object.keys(ratingColors).map((color) => (
            <Button
              key={color}
              variant={selectedRating === color ? 'contained' : 'outlined'}
              color={ratingColors[color]}
              onClick={() => completeCase(caseId, color)}>
              <CircleIcon />
            </Button>
          ))}
        </Stack>
      </Box>
    </>
  );
}

RatingButtons.propTypes = {
  caseId: PropTypes.string.isRequired
};
